<template>
  <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="920px" :before-close="handleClose">
    <el-form ref="standardForm" :model="standardForm" :rules="rules" class="standardForm" label-width="140px" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label="列表名称" prop="listPageName">
            <el-input v-model="standardForm.listPageName" maxlength="30" show-word-limit clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="列表编号" prop="listPageCode">
            <el-input v-model="standardForm.listPageCode" maxlength="20" show-word-limit clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="列表页描述">
        <el-input v-model="standardForm.remark" :autosize="{ minRows: 1, maxRows: 3 }" type="textarea" maxlength="100" show-word-limit />
      </el-form-item>
      <el-form-item label="列表布局">
        <el-row>
          <el-col v-for="item in pageLayoutList" :key="item.id" :span="8">
            <el-radio v-model="standardForm.pageLayout" :label="item.id">{{ item.name }}</el-radio>
          </el-col>
        </el-row>
      </el-form-item>

      <tableSqlConfig v-if="standardForm.pageLayout !== 'tabs-table'" :majorList="majorList" :standardForm="standardForm"></tableSqlConfig>

      <el-tabs v-else v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit">
        <el-tab-pane v-for="(item, index) in standardForm.tabs" :key="item.id" :label="item.title" :name="item.id">
          <el-form-item label="tab名称">
            <el-input v-model="item.title" maxlength="20" show-word-limit clearable />
          </el-form-item>
          <tableSqlConfig
            ref="tableSqlConfig"
            :majorList="majorList"
            :standardForm="standardForm.tabs[index]"
            :index="index"
            sqlField="sql"
            orderExprField="orderExpr"
            businessModelListField="businessModelList"
            tableNameField="tableName"
          ></tableSqlConfig>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveGroup, queryMajorList, getDdynTableListDetail, updateDynTableList, querySqlByTableName } from "@/CommonDP/service/listFlow-service";
import tableSqlConfig from "./components/tableSqlConfig.vue";
import { merge } from "lodash";

const newEmptyStandardForm = () => ({
  listPageName: "",
  listPageCode: "",
  businessModelList: [],
  sql: "",
  orderExpr: "",
  isPage: 1,
  remark: "",
  tableName: "",
  groupId: "",
  pageLayout: "table",
  tabs: []
});

export default {
  components: { tableSqlConfig },
  props: {
    title: {
      type: String,
      default: "新增"
    }
  },

  data() {
    return {
      dialogVisible: false,
      pageLayoutList: [
        {
          id: "table",
          name: "默认（单列表）"
        },
        {
          id: "tree-table",
          name: "左树右表"
        }
        // {
        //   id: "tabs-table",
        //   name: "多tab页"
        // }
      ],
      rules: {
        listPageName: [{ required: true, message: "请输入列表名称", trigger: "change" }],
        listPageCode: [{ required: true, message: "请输入列表编号", trigger: "blur" }]
        // businessModelList: [{ required: true, message: "请选择业务模型", trigger: "change" }],
        // tableName: [{ required: true, message: "请选择主业务模型", trigger: "change" }],
        // sql: [{ required: true, message: "请输入sql", trigger: "change" }]
      },
      standardForm: newEmptyStandardForm(),
      majorList: [],
      primaryKeyList: [],
      cmOptions: {
        tabSize: 4,
        mode: "text/x-sql",
        theme: "xq-light",
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        matchBrackets: true, // 括号匹配
        lineWrapping: true,
        // 加提示
        hintOptions: {
          completeSingle: false
        }
      },
      editableTabsValue: "0"
    };
  },

  watch: {
    //   'standardForm.businessModelList': {
    //     deep: true,
    //     handler (arr) {
    //       console.log('standardForm.businessModelList', arr);
    //       if (this.dialogVisible && arr?.length > 0) {
    //         this.queryPrimaryKeyList(arr)
    //       }
    //     }
    //   }
    "standardForm.pageLayout": {
      handler(val) {
        if (val === "tabs-table") {
          // TODO 这里处理新增
          if (this.title === "新增") {
            this.initEditableTabs();
          } else {
            if (!this.standardForm.tabs.length) {
              this.initEditableTabs();
            }
          }
        }
      }
    }
  },
  mounted() {
    // this.init()
  },
  methods: {
    expose_showDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.tableSqlConfig?.map((instance) => {
          instance.resetCount();
        });
        this.$refs.standardForm.resetFields();
      });
    },
    expose_hideDialog() {
      this.dialogVisible = false;
      // this.$refs.standardForm.resetFields();
    },
    init(data, index) {
      this.standardForm = newEmptyStandardForm();
      const groupId = data?.groupId || "";
      this.standardForm.groupId = groupId;
      this.expose_showDialog();
      this.queryMajorList(groupId);
      if (this.title === "编辑") {
        this.getDdynTableListDetail(data.listPageId);
      }
      console.log(index);
      if (this.standardForm.pageLayout === "tabs-table" && index) {
        this.editableTabsValue = this.standardForm.tabs[index].id;
      }
      // this.queryPrimaryKeyList(groupId);
    },
    queryMajorList(groupId) {
      queryMajorList(groupId).then((res) => {
        this.majorList = res.data.map((item) => {
          item.tableDesc = `${item.tableDesc}(${item.tableName})`;
          return item;
        });
      });
    },

    async querySqlByTableName() {
      if (this.standardForm.tableName) {
        const res = await querySqlByTableName(this.standardForm.tableName);
        const { querySql, sortExpr } = res.data;
        this.standardForm.sql = querySql;
        this.standardForm.orderExpr = sortExpr;
      } else {
        this.standardForm.sql = "";
      }
    },

    initEditableTabs() {
      this.standardForm.tabs = [];
      this.handleTabsEdit(null, "add");
    },

    handleTabsEdit(targetName, action) {
      if (action === "add") {
        const id = `${Math.floor(Math.random() * 9000) + 1000}`;
        this.editableTabsValue = id;
        this.standardForm.tabs.push({
          id,
          title: "New Tab",
          sql: "",
          orderExpr: "",
          businessModelList: "",
          tableName: ""
        });
      }
      if (action === "remove") {
        const tabs = this.standardForm.tabs;
        let activeName = this.editableTabsValue;
        const index = this.editableTabsValue.findIndex((tab) => tab.id === activeName);
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.id === targetName) {
              const nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.id;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.standardForm.tabs.splice(index, 1);
      }
    },

    getDdynTableListDetail(listPageId) {
      getDdynTableListDetail(listPageId).then((res) => {
        this.standardForm = merge(newEmptyStandardForm(), res.data);
        if (!this.standardForm.pageLayout) this.standardForm.pageLayout = "table";
      });
    },

    // queryPrimaryKeyList (arr) {
    //   if (arr?.length > 0) {
    //     queryDynMetaPrimaryKeyList({
    //       "tableNameList": arr
    //     }).then(res => {
    //       this.primaryKeyList = res.data.map(item => {
    //         item.columnName = `${item.columnName}(${item.tableName})`
    //         return item
    //       });
    //     });
    //   }
    // },

    handleClose() {
      this.expose_hideDialog();
      this.standardForm = newEmptyStandardForm();
    },
    handleConfirm() {
      const { standardForm: params } = this;
      this.$refs.standardForm.validate((valid) => {
        if (valid) {
          const request = this.title === "编辑" ? updateDynTableList : saveGroup;
          request(params).then((data) => {
            if (data.result === "0") {
              this.$message.success(this.title === "编辑" ? "编辑成功" : "添加成功");
              this.$emit("initTree", this.$parent?.sideNode?.level === 4);
              this.expose_hideDialog();
            } else {
              this.$message.warning("添加失败");
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.codemirror {
  line-height: 20px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.standardForm {
  ::v-deep .el-tabs__header {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
  ::v-deep .el-tabs__new-tab {
    float: inline-end;
  }
  ::v-deep .el-tabs__nav-wrap {
    width: fit-content;
  }
  ::v-deep .el-tabs__nav-scroll {
    width: fit-content;
  }
}
</style>
